import React, { Component } from 'react';


import Header from '../components/header/Header';
import Banner from '../components/banner/Banner';
import Auth from '../components/auth/Auth';
import Footer from '../components/footer/Footer';
import Addresses from '../components/addresses/Addresses';
import Checkout from '../components/checkout/Checkout'
import landingService from '../services/landing.service'
import couponService from '../services/coupon.service'
import orderService from '../services/order.service';
import userService from '../services/user.service';


declare var $;
declare var FBExtensions;

class PromoFb extends Component {

  constructor(props) {
      super(props);
      this.state = {
        dataCoupon: [],
        loading: true,
        logued: false,
        addressSelected: false,
        selectedAddress: [],
        error: '',
        couponData: [],
        userData: null,
        shippingValue: 0
      };
      this.logout = this.logout.bind(this)
      this.stepBack = this.stepBack.bind(this)
      this.getUserData = this.getUserData.bind(this)
      this.getShippingCharges =   this.getShippingCharges.bind(this)
    }

  async componentWillMount() {
    this.setState({
      logued: true
    })
      let dataCoupon = await landingService.getLandingData(this.props.match.params.token)
        if(dataCoupon.country) {
          this.setState({ dataCoupon, loading: false})
          localStorage.setItem('country', dataCoupon.country)
          if(dataCoupon.fb_only) {
            this.isFacebookApp()
          }
          if(localStorage.getItem('accessToken')) {
            this.setState({
              logued: true
            })
            this.getUserData()
          }
       } else {
         document.location.href = '/404'
       }

       FBExtensions.requestUserInfoField(
         (result) => {
           console.log(result);

        //     let response = await userService.getUserByEmail("juanchoabdon@hotmail.com")
             // {
             //   name: "John Doe",
             //   first_name: "John",
             //   last_name: "Doe",
             //   picture: {
             //     data: {
             //       url: "http://i.imgur.com/FaSFV2A.jpg"
             //     }
             //   }
             // }
           },
         (errorCode, errorMessage) => {

         },
         'public_profile', 'email'
       );

    this.getCurrentPosition()
  }

  getCurrentPosition() {
    FBExtensions.requestCurrentPosition(
  function(result) {
    console.log(result);
    alert(result.coords.latitude)
      // {
      //   coords: { // Space needle in Seattle
      //     latitude: 47.620419,
      //     longitude: -122.349256,
      //     accuracy: 5, // accuracy in meters.
      //   },
      //   timestamp: 1472844702318,
      // }
  },
  function(errorCode, errorMessage) {
    if (errorCode === 1) {
      // the user has denied the permission

    } else {

    }
  }
);
  }

  componentDidMount() {

  }

  isFacebookApp() {
     var ua = navigator.userAgent || navigator.vendor;
     if( !( (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1) )) {
       document.location.href = '/403'
     }
   }

  handleAuth(e) {
    this.getUserData()
  }

async handleSelectedAddress(address) {
  $('.continue').button('loading');
     this.setState({
       selectedAddress: address,
       error: ''
    })
    let coupon = {
     coupon: {
       code: this.state.dataCoupon.coupon_code,
       lng: address.lng,
       lat: address.lat,
       purchase_type: "now",
       token: localStorage.getItem('accessToken')
     }
   }
     let response = await couponService.redeemCoupon(coupon)
     if(!response.error) {
       response.coupon_code = this.state.dataCoupon.coupon_code;
       response.cc_only = this.state.dataCoupon.cc_only;
       if( !response.shipping ) {
          this.getShippingCharges(address.lng, address.lat);
       }
       this.setState({
         couponData: response,
         addressSelected: true
       })
     } else {
       this.setState({
         error: response.error.message
       })
      $('.continue').button('reset');
     }
  }

  async getShippingCharges(lng,lat) {
    let response = await orderService.getShippingCharges(lat ,lng)
    let  shippingCharge = response[this.state.dataCoupon.store_type];
    let shippingValue = shippingCharge[0].value;
    this.setState({
      shippingValue
    })
  }

  async getUserData() {
    let response = await userService.getUserData()
    this.setState({
      userData: response,
      logued: true
    })
    localStorage.setItem('user_data', JSON.stringify(response))
    $('.fb').button('reset');
    $('.login').button('reset');
  }

  logout() {
    this.setState({
      logued: false,
      addressSelected: false
    })
    localStorage.removeItem('accessToken')
  }

  stepBack() {
    this.setState({
      addressSelected: false
    })
  }

  render() {
    return (
        <div >
        <Header></Header>
        <div id="content_wrapper">
          <Banner dataCoupon={this.state.dataCoupon} callto='Pide ya!'></Banner>

          { !this.state.logued  && <Auth logued={this.handleAuth.bind(this)}></Auth> }
          { (this.state.logued && !this.state.addressSelected)   && <Addresses  userData={this.state.userData} error={this.state.error} setSelectedAddress={this.handleSelectedAddress.bind(this)}></Addresses> }
          { this.state.addressSelected  && <Checkout shippingValue={this.state.shippingValue} showProducts="true" selectedAddress={this.state.selectedAddress} couponData={this.state.couponData}></Checkout> }
            <div className="text-center actions">
          { this.state.logued &&
             <p>
              {this.state.addressSelected &&
                <a className="logout" onClick={this.stepBack}>Atrás  | </a>
              }
               <a  className="logout" onClick={this.logout}> Salir </a></p>
          }
            </div>

          <Footer text="Pide ya!"></Footer>
        </div>
        </div>

    );
  }
}




export default PromoFb;



// WEBPACK FOOTER //
// ./src/modules/PromoFb.js